interface WaveIconProps {
  size?: 'sm' | 'md' | 'lg'
  animate?: boolean
  className?: string
}

export function WaveIcon({ size = 'sm', animate = false, className = '' }: WaveIconProps) {
  const heights = {
    sm:  [4, 7, 9, 7, 4],
    md:  [6, 10, 14, 10, 6],
    lg:  [8, 14, 20, 14, 8],
  }
  const widths = { sm: 'w-[2px]', md: 'w-[3px]', lg: 'w-[4px]' }
  const gaps = { sm: 'gap-[2px]', md: 'gap-[3px]', lg: 'gap-[4px]' }
  const bars = heights[size]
  const w = widths[size]
  const g = gaps[size]

  return (
    <>
      {animate && (
        <style>{`
          @keyframes wi-1{0%,100%{height:${bars[0]}px}50%{height:${bars[2]}px}}
          @keyframes wi-2{0%,100%{height:${bars[1]}px}50%{height:${bars[2]*1.2}px}}
          @keyframes wi-3{0%,100%{height:${bars[2]}px}50%{height:${bars[2]*1.4}px}}
          @keyframes wi-4{0%,100%{height:${bars[3]}px}50%{height:${bars[2]*1.2}px}}
          @keyframes wi-5{0%,100%{height:${bars[4]}px}50%{height:${bars[2]}px}}
        `}</style>
      )}
      <span className={`inline-flex items-center ${g} ${className}`}>
        {bars.map((h, i) => (
          <span
            key={i}
            className={`${w} rounded-full bg-[#FD802E]`}
            style={animate ? {
              animationName: `wi-${i+1}`,
              animationDuration: ['0.8s','0.6s','0.7s','0.9s','0.75s'][i],
              animationTimingFunction: 'ease-in-out',
              animationIterationCount: 'infinite',
              animationDelay: ['0s','0.1s','0.05s','0.15s','0.08s'][i],
              height: `${h}px`,
              display: 'block',
            } : { height: `${h}px`, display: 'block' }}
          />
        ))}
      </span>
    </>
  )
}
